import { useCallback } from 'react';

export const useHandlers = (
  handleActiveAnimation: (
    event:
      | React.MouseEvent<HTMLButtonElement>
      | React.KeyboardEvent<HTMLButtonElement>,
  ) => void,
  disabled?: boolean,
  loading?: boolean,
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void,
) => {
  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      if (!disabled && !loading) {
        onClick && onClick(event);
      }
      event.preventDefault();
    },
    [disabled, loading, onClick],
  );

  const handleSubmit = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      if (disabled || loading) {
        event.preventDefault();
      }
    },
    [disabled, loading],
  );

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLButtonElement>) => {
      if (event.key === 'Enter') {
        handleActiveAnimation(event);
      }
    },
    [handleActiveAnimation],
  );

  const handleMouseDown = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      handleActiveAnimation(event);
    },
    [handleActiveAnimation],
  );

  return {
    handleClick,
    handleKeyDown,
    handleMouseDown,
    handleSubmit,
  };
};
